export type TruckVendorSearchType = "OWNER" | "CONTRACTOR" | "";

export const getTruckVendorTypeByOwnership = (
  ownership?: string | null,
): TruckVendorSearchType => {
  if (ownership === "INVESTMENT" || ownership === "DRY_RENTAL") {
    return "OWNER";
  }

  if (ownership === "SERVICE") {
    return "CONTRACTOR";
  }

  return "";
};

export const getTruckVendorSearchOwnershipByOwnership = (
  ownership?: string | null,
) => {
  if (ownership === "INVESTMENT" || ownership === "DRY_RENTAL") {
    return ownership;
  }

  return "";
};
